import { useState } from 'react'
import { DEFAULT_HOMEPAGE_SLUG } from '../constants'
import { DEFAULT_RUNTIME_HOME_SETTINGS, type RuntimeHomeSettings } from '../runtimeSettings'
import type { Route } from '../types'
import { useHomeFavicon } from './home-runtime/useHomeFavicon'
import { useHomePageContent } from './home-runtime/useHomePageContent'
import { useHomePageRouteRefresh } from './home-runtime/useHomePageRouteRefresh'
import { useHomeRuntimeBootstrap } from './home-runtime/useHomeRuntimeBootstrap'
import { useHomeSlideState } from './home-runtime/useHomeSlideState'
import { useRuntimeAdminFlag } from './home-runtime/useRuntimeAdminFlag'

type Params = {
  routeMode: Route['mode']
}

export const useShopHomeRuntime = ({ routeMode }: Params) => {
  const isAdmin = useRuntimeAdminFlag()
  const {
    slides,
    setSlides,
    currentSlide,
    currentIndex,
    setCurrentIndex,
    goNext,
    goPrev,
  } = useHomeSlideState()
  const { homePageData, homePageLoading, homePageError, loadHomePage } = useHomePageContent()

  const [status, setStatus] = useState<string>('')
  const [homepageSlug, setHomepageSlug] = useState<string>(DEFAULT_HOMEPAGE_SLUG)
  const [homeSettings, setHomeSettings] = useState<RuntimeHomeSettings>(DEFAULT_RUNTIME_HOME_SETTINGS)

  useHomeRuntimeBootstrap({
    loadHomePage,
    setSlides,
    setHomeSettings,
    setStatus,
    setHomepageSlug,
  })
  useHomePageRouteRefresh({ routeMode, homepageSlug, loadHomePage })
  useHomeFavicon(homeSettings.faviconUrl)

  return {
    isAdmin,
    slides,
    currentSlide,
    currentIndex,
    setCurrentIndex,
    goNext,
    goPrev,
    status,
    homeSettings,
    homePageData,
    homePageLoading,
    homePageError,
  }
}
